<mat-sidenav-container class="w-100" [hasBackdrop]="false">
  <mat-sidenav-content>
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="loader-overlay" [class.shown]="isLoading">
          <fa-icon [icon]="icons.falSpinnerThird" size="3x" animation="spin"></fa-icon>
        </div>
        <div class="col-lg-9 col-md-12 chart">
          <div class="row position-relative flex-column">
            <div class="map-container" [class.loading]="isLoading" id="fix-detail"></div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>